const initialValues = {
  companyName: "",
  companyWebsite: "",
  email: "",
};

export default initialValues;
